<ndc-dynamic
    [ndcDynamicComponent]="templateWidgetComponent$ | async"
    [ndcDynamicInputs]="{ config: templateWidgetComponentConfig }"
    [ndcDynamicOutputs]="{}"
/>
